import { useEffect, useState } from 'react';
import { IconBrandWhatsapp } from '@tabler/icons-react';
import ImageWithSkeleton from './ComponentsPage/ImageWithSkeleton';

const KinCommunity = () => {
  const eventImages = Array.from(
    { length: 6 },
    (_, index) => `kin/assest/about/eventspace/event-${index + 1}.webp`,
  );
  const [activeImageIndex, setActiveImageIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveImageIndex((prev) => (prev + 1) % eventImages.length);
    }, 3500);

    return () => clearInterval(timer);
  }, [eventImages.length]);

  const goToPrevious = () => {
    setActiveImageIndex((prev) => (prev - 1 + eventImages.length) % eventImages.length);
  };

  const goToNext = () => {
    setActiveImageIndex((prev) => (prev + 1) % eventImages.length);
  };

  const wa = '6281290904617';
  const waNumber = wa.replace(/\D/g, '');
  const waMessage =
    'Halo KiN Space, saya tertarik untuk booking Event Space untuk acara saya. Boleh minta informasi paket, kapasitas, dan ketersediaan jadwal?';
  const waHref = `https://wa.me/${waNumber}?text=${encodeURIComponent(waMessage)}`;

  return (
    <section id="kincommunity" aria-labelledby="kincommunity-title" className="relative">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="grid items-center gap-8 md:grid-cols-2 md:gap-12">
          <div className="relative h-64 overflow-hidden rounded-2xl bg-slate-100 sm:h-72 md:h-80">
            <ImageWithSkeleton
              src={eventImages[activeImageIndex]}
              alt={`Event & Playground ${activeImageIndex + 1}`}
              aspect="h-full"
              object="object-cover"
              className="h-full w-full"
            />

            <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/45 to-transparent" />

            <button
              type="button"
              onClick={goToPrevious}
              aria-label="Previous image"
              className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-white/85 px-2.5 py-1.5 text-xs font-bold text-slate-700 shadow-sm transition hover:bg-white sm:left-3 sm:px-3 sm:py-2 sm:text-sm">
              ←
            </button>

            <button
              type="button"
              onClick={goToNext}
              aria-label="Next image"
              className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-white/85 px-2.5 py-1.5 text-xs font-bold text-slate-700 shadow-sm transition hover:bg-white sm:right-3 sm:px-3 sm:py-2 sm:text-sm">
              →
            </button>

            <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 items-center gap-2">
              {eventImages.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  aria-label={`Go to image ${index + 1}`}
                  onClick={() => setActiveImageIndex(index)}
                  className={`h-2.5 rounded-full transition-all ${
                    index === activeImageIndex ? 'w-6 bg-white' : 'w-2.5 bg-white/60'
                  }`}
                />
              ))}
            </div>
          </div>

          <div className="space-y-4">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-kin-textdark sm:text-sm sm:tracking-widest">
              Event Space
            </span>
            <h2 className="mt-1 text-2xl font-bold tracking-tight text-pretty text-primary-main sm:mt-2">
              A Refined Setting for Meaningful Gatherings
            </h2>
            <p className="text-sm leading-relaxed text-kin-text sm:text-base">
              KiN Space offers a thoughtfully designed, multifunctional venue for intimate and
              meaningful events. Ideal for birthdays, workshops, brand gatherings, and
              family-friendly celebrations, our space combines an event room, exhibition area, and
              indoor playground within one seamless environment.
            </p>
            <blockquote className="border-l-4 border-emerald-500 pl-4 text-sm italic text-slate-700 sm:text-base">
              "A refined yet child-friendly setting—where memorable moments are created comfortably
              for both adults and little ones."
            </blockquote>
            <a
              href={waHref}
              target="_blank"
              rel="noreferrer"
              className="inline-flex w-full items-center justify-center gap-2 rounded-2xl bg-emerald-600 px-6 py-3.5 text-center text-sm font-bold text-white transition-all hover:bg-emerald-700 hover:shadow-lg active:scale-[0.98] sm:py-4">
              <IconBrandWhatsapp className="h-5 w-5" stroke={2.2} />
              Book Your Event via WhatsApp
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KinCommunity;
